import apiClient from './AxiosHttp'

const createInquiry = (details) => {
    return apiClient.post('/inquiries/create/', details)
}

const listPosts = (params) => {
    return apiClient.get(`/blog/posts/${params}`)
}

const getPost = (id) => {
    return apiClient.get(`/blog/post/${id}/`)
}

const getCareers = (page = 1) => {
    return apiClient.get('/careers/list/', { params: { page } })
}

const getCareerStats = () => {
    return apiClient.get(`/careers/stats/`)
}

const getMaintenanceStatus = () => {
    return apiClient.get('/inquiries/maintenance-status/')
}

const blogServices = {
    createInquiry,
    listPosts,
    getPost,
    getCareers,
    getCareerStats,
    getMaintenanceStatus
}

export default blogServices